import Actions            from 'Redux/Actions';
import { EventRepository } from 'Domain/Repositories';
import { ofType }         from 'redux-observable';
import { from }           from 'rxjs';
import { mergeMap }       from 'rxjs/operators';
import { TEpic }          from 'Redux/Config';

export const assignEventEmployeesEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.assignEventEmployeesRequest.type),
    mergeMap(action => from(
      EventRepository.updateEmployees(action.payload.id, action.payload.userIds)
        .then(({ userIds }: { userIds: string[] }) => Actions.assignEventEmployeesSuccess({ userIds }))
        .catch((error: Error) => Actions.assignEventEmployeesFailure({ error })),
    )),
  );
};
